import { Badge } from "@mantine/core";
import { calcBMI } from "../../../helpers/utilities";
import { Divider } from "antd";

const ViewVitals = ({ vitals }) => {
  return (
    <div className="row">
      <div className="col-9">
        <table className="table table-bordered table-sm mb-0">
          <tbody>
            <tr>
              <td>Temperature</td>
              <td>
                <strong>{vitals?.temperature}</strong>{" "}
                <span className="text-muted ms-1">℃</span>
              </td>
            </tr>
            <tr>
              <td>BP</td>
              <td>
                <strong>{vitals?.bloodPressure}</strong>{" "}
                <span className="text-muted ms-1">mmHg</span>
              </td>
            </tr>
            <tr>
              <td>Pulse</td>
              <td>
                <strong>{vitals?.pulse}</strong>{" "}
                <span className="text-muted ms-1">bpm</span>
              </td>
            </tr>
            <tr>
              <td>Weight</td>
              <td>
                <strong>{vitals?.weight}</strong>{" "}
                <span className="text-muted ms-1">kg</span>
              </td>
            </tr>
            <tr>
              <td>Height</td>
              <td>
                <strong>{vitals?.height}</strong>{" "}
                <span className="text-muted ms-1">m</span>
              </td>
            </tr>
            <tr>
              <td>Oxygen</td>
              <td>
                <strong>{vitals?.oxygenSaturation}</strong>
              </td>
            </tr>
            <tr>
              <td>Respiration</td>
              <td>
                <strong>{vitals?.respiration}</strong>{" "}
                <span className="text-muted ms-1">cpm</span>
              </td>
            </tr>
            <tr>
              <td>RBS/FBS</td>
              <td>
                <strong>{vitals?.rbs}</strong>
              </td>
            </tr>
            <tr>
              <td>Pain</td>
              <td>
                <strong>{vitals?.pain}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="col-3">
        <Badge variant="filled" color="gray">
          BMI
        </Badge>
        <h1 className="mt-0">{calcBMI(vitals.weight, vitals.height) || 0}</h1>
      </div>
      {vitals.comments && (
        <div className="row">
          <div className="col-12">
            <Divider />
            <strong>Notes</strong>: {vitals?.comments}
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewVitals;
